import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon, ArrowUpRightIcon } from 'lucide-react';
import { bookingItem, business } from '../../data/site';
export function ContactSection() {
  return <section aria-labelledby="contact-title" className="w-full bg-ink text-white" data-id="element-32" data-mp="1v3tspv8n1u0b">
      <div className="mx-auto max-w-7xl px-5 py-24 sm:px-8 lg:py-32" data-id="element-33" data-mp="203g37wx30w5f">
        <h2 id="contact-title" className="text-lg font-medium text-fog" data-id="element-34" data-mp="201lm6toxlo6m">
          Prêt à redonner une seconde jeunesse à votre véhicule ?
        </h2>
        <a href={business.phoneHref} className="group mt-4 inline-flex items-center gap-4 font-display text-[clamp(2.75rem,10vw,9rem)] font-bold leading-none tracking-[-0.04em] text-white transition-colors duration-200 ease-out hover:text-lime" data-id="element-35" data-mp="1r41gn8k1d5q7">
          {business.phone}
          <ArrowUpRightIcon className="h-[0.5em] w-[0.5em] shrink-0 text-lime transition-transform duration-200 ease-out group-hover:-translate-y-1 group-hover:translate-x-1" aria-hidden="true" data-id="element-36" data-mp="36lbmc1wi9d94" />
        </a>

        <div className="mt-16 grid gap-10 border-t border-white/10 pt-10 md:grid-cols-[1fr_1fr_auto] md:items-start" data-id="element-37" data-mp="27hxw4l72epwt">
          <div data-id="element-38" data-mp="22ibfs2vxwtjs">
            <h3 className="text-sm text-fog" data-id="element-39" data-mp="2h9bzx561ubvr">Où sommes-nous ?</h3>
            <a href={business.mapsHref} target="_blank" rel="noreferrer" className="mt-2 block text-lg font-medium transition-colors duration-150 ease-out hover:text-lime" data-id="element-40" data-mp="2h8se3dda33cg">
              {business.addressLine1}
              <br data-id="element-41" data-mp="1omqyfbvv0jeh" />
              {business.addressLine2}
            </a>
          </div>
          <div data-id="element-42" data-mp="1jnebkr4zncbw">
            <h3 className="text-sm text-fog" data-id="element-43" data-mp="1jno0sci7lfgj">Horaires</h3>
            <dl className="mt-2 space-y-1 text-lg" data-id="element-44" data-mp="1xme3q8rpm9ct">
              {business.hours.map(h => <div key={h.days} className="flex flex-wrap gap-x-3" data-id="element-45" data-mp="1tiocfbjnhdo3">
                  <dt className="font-medium" data-id="element-46" data-mp="39084zjlvbc8h">{h.days}</dt>
                  <dd className="text-fog" data-id="element-47" data-mp="38yonxqse0x5n">{h.time}</dd>
                </div>)}
            </dl>
          </div>
          <Link to={bookingItem.to} className="group inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full bg-lime px-8 py-4 font-semibold text-ink transition-[transform,background-color] duration-150 ease-out hover:bg-white active:scale-[0.97]" data-id="element-48" data-mp="21nz6tmokf388">
            Prendre rendez-vous
            <ArrowRightIcon className="h-4 w-4 transition-transform duration-150 ease-out group-hover:translate-x-0.5" aria-hidden="true" data-id="element-49" data-mp="2fmqi71c1maso" />
          </Link>
        </div>
      </div>
    </section>;
}